import React from 'react';

/**
 * Prosty komponent tła strony z jednolitym kolorem
 */
const PageBackground = () => {
  return (
    <div className="page-background" data-testid="page-background">
      {/* Tutaj jest tylko jednokolorowe tło, które jest stylowane w CSS */}
    </div>
  );
};

export default PageBackground;
